import { useBack, useBackMultipart } from "../http";
import { AccountDTO } from "../types/AccountDTO";
import { ComplaintDTO } from "../types/ComplaintDTO";
import { DocumentsGroupDTO } from "../types/DocumentsGroupDTO";
import { SGGCompanyDTO } from "../types/SGGCompanyDTO";

export class ComplaintService {
	constructor() {}
	axiosInstance = useBack();
	axiosInstanceMultipart = useBackMultipart();

	async getGroups() {
		try {
			const response = await this.axiosInstance.get<DocumentsGroupDTO[]>('/complaints/groups');
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os grupos de empresas`, error);
			return undefined;
		}
	}

	async createGroup(cnpj: string) {
		const data = { cnpj: cnpj }
		return await this.axiosInstance.post(`/complaints/groups`, data);
	}

	async update(id: number, active: boolean) {
		const data = { active: active }
		return await this.axiosInstance.put(`/complaints/groups/${id}`, data);
	}

	async getcompanies(id: number) {
		const response = await this.axiosInstance.get<SGGCompanyDTO[]>(`/complaints/groups/${id}/companies`);
		return { ...response };
	}

	async getComplaints() {
		const response = await this.axiosInstance.get<ComplaintDTO[]>('/complaints')
		return { ...response };
	}

	async getComplaint(id: string) {
		const response = await this.axiosInstance.get<ComplaintDTO>(`/complaints/${id}`)
		return { ...response };
	}

	async getUsers(id: string) {
		const response = await this.axiosInstance.get<AccountDTO[]>(`/complaints/users?companyId=${id}`)
		return { ...response };
	}

	async save(v: ComplaintDTO) {
		return await this.axiosInstance.post(`/complaints`, v);
	}

	async register(id: string | undefined, payload: FormData) {
		return await this.axiosInstanceMultipart.post(`/complaints/${id}/register`, payload);
	}

	async getSectors(id: string) {
		const response = await this.axiosInstance.get<string[]>(`/complaints/${id}/sectors`);
		return { ...response };
	}

	async getPositions(id: string | undefined, sector: string) {
		const response = await this.axiosInstance.get<string[]>(`/complaints/${id}/positions?sector=${sector}`);
		return { ...response };
	}
}